//Package Import
import axiosClient from "./axiosclient";

//GET
export const fetchItems = async (endpoint) => {
  const response = await axiosClient.get(endpoint);
  return [response.status,response.data];
};

//POST
export const createItem = async (endpoint,itemData) => {
  const response = await axiosClient.post(endpoint, itemData);
  return [response.status,response.data];
};
